<form [formGroup]="formGroup">
  
  <ng-container [ngSwitch]=processingClassSubtype>
    <ng-container *ngSwitchCase="processingClassSubTypeEnum.Hospital">
      <ng-container *ngTemplateOutlet="hospitalSubType;"></ng-container>
    </ng-container>
  </ng-container>
  
  <mat-grid-list cols="2" rowHeight="100px">
    <!-- Workman Compensation Case Number-->
    <mat-grid-tile>
      <mat-form-field class="w-50">
        <mat-label>Workmen’s Compensation Case Number</mat-label>
        <input type="text" matInput [formControlName]="controls.WorkmansCompensationCaseNumber">
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Workmen\'s Compensation Case Number')">help_outline
      </mat-icon>
    </mat-grid-tile>
    
    <!--Communication Number-->
    <mat-grid-tile>
      <mat-form-field class="w-50">
        <mat-label>Communication Number</mat-label>
        <input [formControlName]="controls.CommunicationNumber" type="text" matInput required>
        
        <mat-error *ngIf="communicationNumberAbstractControl.invalid">
          <span *ngIf="communicationNumberAbstractControl.errors?.invalidMobileNumber">Invalid mobile number.</span>
        </mat-error>
      
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Communication Number')">
        help_outline
      </mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  
  <mat-grid-list cols="2" rowHeight="100px">
    
    <!--Road Accident Case Number-->
    <mat-grid-tile>
      <mat-form-field class="w-50">
        <mat-label>Road Accident Case Number</mat-label>
        <input type="text" matInput [formControlName]="controls.RoadAccidentFundCaseNumber">
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Road Accident Case Number')">help_outline</mat-icon>
    </mat-grid-tile>
  </mat-grid-list>
  
  
  <ng-template #hospitalSubType>
    <mat-grid-list cols="2" rowHeight="100px">
      <!---------------------------->
      <!-- Transport Type-->
      <!---------------------------->
      <mat-grid-tile>
        <mat-form-field class="w-50">
          <mat-label>Transport Type</mat-label>
          <mat-select required [formControlName]="controls.TransportType">
            <mat-option *ngFor="let transportType of transportTypeLookUpValues"
                        [value]="transportType.value">
              {{transportType.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Transport Type')">help_outline</mat-icon>
      </mat-grid-tile>
      
      <!---------------------------->
      <!-- Reason for Admission-->
      <!---------------------------->
      <mat-grid-tile>
        <mat-form-field class="w-50">
          <mat-label>Reason for Admission</mat-label>
          <mat-select required [formControlName]="controls.ReasonForAdmission">
            <mat-option *ngFor="let reasonForAdmission of reasonForAdmissionLookUpValues"
                        [value]="reasonForAdmission.value">
              {{reasonForAdmission.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Reason for Admission')">help_outline</mat-icon>
      </mat-grid-tile>
    </mat-grid-list>
  </ng-template>

</form>

<!---------------------------->
<!--Navigation Buttons-->
<!---------------------------->
<div class="button-container">
  <button color="primary" mat-raised-button matStepperPrevious>Back</button>
  <button (click)="resetDetailsFormGroup()" color="warn" mat-raised-button>Clear</button>
  <button color="primary" mat-raised-button matStepperNext>Next</button>
</div>
